import React, { useEffect } from "react";
import { Modal, Form, Button } from "antd";
import { useTranslation } from "react-i18next";
import CurrentPassword from "./change-password-form-elements/CurrentPassword";
import NewPassword from "./change-password-form-elements/NewPassword";
import ConfirmPassword from "./change-password-form-elements/ConfirmPassword";
import { useSelector } from "react-redux";
import { changePassword } from "@src/redux/index";

interface ChangePasswordModalProps {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (values: any) => void;
  form: any; // Accept the form instance as a prop
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  visible,
  onCancel,
  onSubmit,
  form, // Receive form instance here
}) => {
  const { t } = useTranslation();
  const { result: passwordChangeResult, loading: passwordChangeLoading } =
    useSelector(changePassword);

  return (
    <Modal
      title={t("changePassword")}
      open={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose={false} // Preserve form data when modal is closed
    >
      <Form layout="vertical" form={form} onFinish={onSubmit}>
        <CurrentPassword />
        <NewPassword />
        <ConfirmPassword />

        <Form.Item>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              style={{ marginRight: 8 }}
              onClick={onCancel}
              className="cancel-btn"
            >
              {t("cancel")}
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={passwordChangeLoading}
            >
              {t("change")}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
